<template>
  <div>

    <div class="sub-nav">
      <span class="sub-nav-icon">
        <i class="cubeic-back" @click="goBack"></i>
      </span>
      <span class="sub-nav-title">在线问答</span>
    </div>

    <div class="container">
      <div class="law-list">
        <div class="item">
          <div class="title">选择分类</div>
          <cube-select
            v-model="value"
            :options="options">
          </cube-select>
          <div class="text">
            <cube-textarea v-model="value2" placeholder="请输入问题描述"></cube-textarea>
          </div>
        </div>
        <div class="item">
          <div class="title">图片上传</div>
          <div class="img-list">
            <span><img src="../assets/law/p1.jpg"></span>
            <span><img src="../assets/law/p2.jpg"></span>
            <span><img src="../assets/law/p1.jpg"></span>
            <span><img src="../assets/law/p1.jpg"></span>
            <span><img src="../assets/law/p1.jpg"></span>
            <span><img src="../assets/law/p1.jpg"></span>
            <span class="add"><i class="icon-add"></i></span>
          </div>
        </div>
        <div class="item">
          <div class="online-box">
            <label><input type="checkbox" value=""/>问答结果公开</label>
          </div>
        </div>
      </div>
      <div class="law-button">
        <span class="btn-green">提交</span>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: "online",

    data() {
      return {
        value: '植物识别',
        options: ['植物识别', '咨询'],

        checkerValue: [],
      }
    },

    methods: {
      goBack() {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
      }
    },

  }
</script>

<style lang="scss" scoped>
  @import "../assets/css/base.scss";
  .law-list {
    padding: 5px 15px 15px 15px;
    background-color: #fff;
  }
  .law-list .item .title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #f2f2f2;
  }
  .law-list .item .text {
    margin-top: 10px;
  }
  .law-list .item .img-list {
    display: flex;
    align-content: space-between;
    flex-wrap: wrap;
  }
  .law-list .item .img-list span {
    margin-bottom: 10px;
    width: 25%;
  }
  .law-list .item .img-list span img {
    display: block;
    margin: 0 auto;
    width: 90%;
    height: 100%;
    border: 1px solid #ddd;
    object-fit: cover;
    object-position: center;
  }
  .law-list .item .img-list span.add {
    position: relative;
  }
  .law-list .item .img-list span.add i {
    position: relative;
    top: 50%;
    display: block;
    margin: -10px auto 0 auto;
    width: 20px;
    height: 20px;
    z-index: 1;
  }
  .law-list .item .img-list span.add:before {
    content: '';
    position: absolute;
    left: 5%;
    display: block;
    width: 90%;
    height: 100%;
    border: 1px solid #ddd;
  }
  .law-list .item .online-box {
    font-size: 14px;
  }


  .law-button {
    margin-top: 15px;
    padding: 0 15px;
  }
  .law-button span {
    display: block;
    height: 40px;
    line-height: 40px;
    font-size: 17px;
    color: #39BF3E;
    text-align: center;
    border: 1px solid #39BF3E;
    border-radius: 20px;
  }
  .law-button span.btn-green {
    color: #fff;
    background-color: #39BF3E;
    border: 1px solid #39BF3E;
  }

  input::-webkit-input-placeholder {
    color: #ddd;
  }
  input:-moz-placeholder {
    color: #ddd;
  }
  input::-moz-placeholder {
    color: #ddd;
  }
  input:-ms-input-placeholder {
    color: #ddd;
  }

</style>



// WEBPACK FOOTER //
// src/components/online.vue